export default __webpack_public_path__ + "static/media/roadmap.6aa89343.png";